export default {
    new: "Новая",
    found_block: "Вошла в блокчейн",
    fail_validated: "Нода отклонила транзу",
    validated: "Нода приняла транзу",
    not_found: "Не найдена в блокчейне"
}